export enum CustomerProductsTableFields {
  id = 'id',
  product = 'product',
  startTime = 'startTime',
  endTime = 'endTime',
  actions = 'actions',
}
